import { useSelector } from 'react-redux';

import {
  selectBalance,
  selectCashierConfiguration,
} from '@cashier/cashier-data-access';
import { getCurrencySymbol } from '@cashier/cashier-shared';

interface UseAccountBalance {
  amount: string | null;
  currencySymbol: string | null;
}

export const useAccountBalance = (): UseAccountBalance => {
  const { currency } = useSelector(selectCashierConfiguration);
  return {
    amount: useSelector(selectBalance),
    currencySymbol: getCurrencySymbol(currency),
  };
};
